module.exports = __webpack_public_path__ + "img/logo-qontak-default.5b9a079.svg";